import { createFileRoute } from '@tanstack/react-router'
import { InvestorPitchesContent } from '../../../features/investor/components/investor-pitches-content'
import { FounderPitchHistory } from '../../../features/pitch/components/founder-pitch-history'
import { useIsFounder } from '../../../hooks/use-user-type'

export const Route = createFileRoute('/_protected/pitches/')({
  component: PitchHistoryPage,
})

function PitchHistoryPage() {
  const isFounder = useIsFounder()

  return isFounder ? <FounderPitchHistory /> : <InvestorPitchesContent />
}
